import { styled } from 'linaria/react';
import { theme } from '../../components/Theme';
import { toRem } from '../../helpers';
import MaxWidth from '../../components/Layout/MaxWidth';
import Heading from '../../components/ui/Heading';
const Container = styled(MaxWidth)`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
`;

const ProductContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
`;

const HeaderWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: ${toRem(24)};
  gap: 1rem;
  justify-content: space-between;
`;

const ProductTitle = styled(Heading)`
  font-size: ${toRem(24)};
  font-weight: ${theme.fontWeights.bold};
  line-height: ${toRem(36)};
`;
const ArticleNumber = styled('span')`
  text-transform: uppercase;
  color: ${theme.colorScheme.mediumgrey};
  font-size: ${toRem(12)};
  display: block;
`;
const FavouriteButtonWrapper = styled('div')`
  padding-top: 0.25rem;
`;
const BadgeWrapper = styled('div')`
  position: absolute;
  z-index: 1;
  ${theme.above.md} {
    padding-left: ${toRem(113)};
  }
`;

const ProductDescriptionContainer = styled('div')`
  width: 100%;
  ${theme.above.md} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const ProductSection = styled('section')`
  line-height: 1.5;

  width: 100%;
  padding-bottom: 1.5rem;

  ${theme.below.md} {
    margin: 0;
  }

  ${theme.above.md} {
    width: calc(50% - 16px);
    padding-bottom: 3rem;
  }

  ${theme.above.lg} {
    :nth-of-type(odd) {
      width: calc(60% - 24px);
    }
    :nth-of-type(even) {
      width: calc(40% - 24px);
    }
  }
`;

const style = {
  Container,
  ProductContainer,
  HeaderWrapper,
  ProductTitle,
  ArticleNumber,
  FavouriteButtonWrapper,
  BadgeWrapper,
  ProductDescriptionContainer,
  ProductSection
};

export default style;
